import { optionIs, rankWith } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { FormItem } from '../../../../../controls/FormItem';
import { FieldProps, WithDynamicFormContext } from '../WithDynamicFormContext';
import { SwitchToggleInput } from '../../../../../controls/SwitchToggleInput';
import './style.scss';
import { get } from 'lodash';
import { currencyFormat } from '../../../../../utils/currency';

const ToggleControl = ({
  path,
  label,
  schema,
  handleChange,
  handleBlur,
  data,
  required,
  uischema,
  disabled,
  formData,
  optionalMessage,
}: FieldProps) => {
  const moreInfo = uischema.options?.moreInfo;
  const controlLabel = uischema.options?.label;
  const link = uischema.options?.link;
  const hideToggle = uischema.options?.hideToggle;
  const { dependentValue, classes, reversed } = uischema.options!;
  const changePath = uischema.options?.changePath;

  return (
    <FormItem
      label={label as string}
      required={required}
      classes="tru-toggle-control"
      moreInfo={moreInfo}
      link={link}
      optionalMessage={optionalMessage}
      reversed={reversed}
    >
      <div className={classes}>
        <div className="field-with-dependent-value">
          {!hideToggle && (
            <SwitchToggleInput
              value={data}
              onBlur={() => handleBlur(path)}
              onChange={(value) => {
                handleChange(path, value);
                if (changePath) {
                  handleChange(
                    changePath,
                    true,
                  );
                }
              }}
              disabled={disabled}
              label={controlLabel as string}
            />
          )}
          {dependentValue && (hideToggle || data) ? (
            <p>
              {(get(formData, dependentValue[0]) ||
                get(formData, dependentValue[1])) &&
                (get(formData, dependentValue[0])
                  ? currencyFormat(get(formData, dependentValue[0]))
                  : currencyFormat(get(formData, dependentValue[1])))}
            </p>
          ) : null}
        </div>
        {schema.description && (
          <p className="description">{schema.description}</p>
        )}
      </div>
    </FormItem>
  );
};

export const ToggleControlEntry = {
  tester: rankWith(10, optionIs('toggle', true)),
  renderer: withJsonFormsControlProps(WithDynamicFormContext(ToggleControl)),
};
